 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		10: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		10: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"9f7fad396670187e6e81d178f914bce534dfdf3b","1":"a42cee80401c046b0be9e34815118bc8428d9343","2":"70eacc7e437efee67816d4b640fb958822a244a1","3":"0f303393c5cd014f6ff8de21f28f845f7099c261","4":"c98c67519a7e41a1eb7972eefa71518a0b19606b","5":"styles","6":"a320c8ed","7":"11dd2a487fbd0b2bc4903be47570e75ed3b372ab","8":"325e8fbac9e8e621cac8d1682aa7a88b146c49f1","9":"f767f3ab81c56a889b3661ba112fbe4febfbe8de","13":"component---toggl-src-articles-index-js","14":"component---toggl-src-case-studies-index-js","15":"component---toggl-src-downloadables-index-js","16":"component---toggl-src-ebooks-index-js","17":"component---toggl-src-integration-index-js","18":"component---toggl-src-invitation-index-js","19":"component---toggl-src-job-index-js","20":"component---toggl-src-pages-404-js","21":"component---toggl-src-pages-fun-and-games-index-js","22":"component---toggl-src-pages-index-index-js","23":"component---toggl-src-pages-jobs-index-js","24":"component---toggl-src-pages-legal-index-js","25":"component---toggl-src-pages-mission-index-js","26":"component---toggl-src-pages-track-adobe-time-tracking-index-js","27":"component---toggl-src-pages-track-anti-surveillance-statement-index-js","28":"component---toggl-src-pages-track-business-resources-index-js","29":"component---toggl-src-pages-track-completed-signup-js","30":"component---toggl-src-pages-track-contact-js","31":"component---toggl-src-pages-track-culture-index-js","32":"component---toggl-src-pages-track-customers-index-js","33":"component---toggl-src-pages-track-demo-request-confirmation-js","34":"component---toggl-src-pages-track-demo-request-js","35":"component---toggl-src-pages-track-device-unsupported-js","36":"component---toggl-src-pages-track-features-index-js","37":"component---toggl-src-pages-track-forgot-password-js","38":"component---toggl-src-pages-track-freelance-time-tracking-index-js","39":"component---toggl-src-pages-track-index-index-js","40":"component---toggl-src-pages-track-integrations-index-js","41":"component---toggl-src-pages-track-legal-beta-js","42":"component---toggl-src-pages-track-legal-data-protection-js","43":"component---toggl-src-pages-track-legal-index-js","44":"component---toggl-src-pages-track-legal-privacy-js","45":"component---toggl-src-pages-track-legal-sub-processors-js","46":"component---toggl-src-pages-track-legal-terms-js","47":"component---toggl-src-pages-track-login-js","48":"component---toggl-src-pages-track-pricing-index-js","49":"component---toggl-src-pages-track-product-demo-index-js","50":"component---toggl-src-pages-track-productivity-resources-index-js","51":"component---toggl-src-pages-track-sso-link-account-js","52":"component---toggl-src-pages-track-sso-login-js","53":"component---toggl-src-pages-track-sso-must-link-js","54":"component---toggl-src-pages-track-time-management-index-js","55":"component---toggl-src-pages-track-time-tracking-large-teams-index-js","56":"component---toggl-src-pages-track-time-tracking-small-teams-index-js","57":"component---toggl-src-pages-track-toggl-button-feedback-js","58":"component---toggl-src-pages-track-toggl-button-login-js","59":"component---toggl-src-paid-ad-landing-pages-index-js","60":"component---toggl-src-personas-index-js","61":"component---toggl-src-product-index-js","62":"component---toggl-src-signup-index-js","63":"component---toggl-src-spokes-index-js","64":"component---toggl-src-templates-track-reset-password-js","65":"component---toggl-src-templates-track-unsubscribe-js","66":"component---toggl-src-timer-index-js","67":"component---toggl-src-webinars-index-js"}[chunkId]||chunkId) + "-" + {"0":"014c455cf60c0d094fd8","1":"cbf7f7f0fde9ffec4f29","2":"b295327e0a5b0a76c3c2","3":"09132b9fc9262b777542","4":"331db886e5c1fbc46bef","5":"29163f9dced6fe4a408a","6":"f85340d170ee348664ff","7":"4bdc203b9cab54204f5b","8":"d3aa5f83cf99a68c4408","9":"aacc6fe9a67a048fbd19","11":"618e9d4446cbd625eb5c","13":"f8c3bbdd1fb8e97c3032","14":"db553afb6c898bbdd52c","15":"8d19cad7fba6bf5a1406","16":"6fdc3be63e7adec683c3","17":"955086a900c125bef724","18":"38b2226ac424e235e75d","19":"864b93cfafc2e42bf847","20":"b5ba6f8198e3f157b386","21":"a933ec7dfec8d35f269e","22":"ca63291ac8b5be480d94","23":"3930aee51a907f54a662","24":"b0c22f6301ac1f21d656","25":"cae6d5e42d0901c8b531","26":"d19dd6af126751e09c87","27":"ff353d8d65b938875561","28":"a6563e7ca92439b0a88d","29":"cee216047204492fdc1f","30":"84f19e463ee9d3577d82","31":"186aa273000e65fa1c82","32":"b4fffc67cb79d2eb5cda","33":"85299ea485b097d7fa60","34":"9d19de31e5bd2cddc3d1","35":"8cd2183132d38cc3cf2d","36":"6d93323e3ccf3257f16c","37":"8838e3360be6e37789db","38":"3f3475ca7ae353570263","39":"e3dc7468c36f82c8d128","40":"0522f22c12334c9fd445","41":"3daea8aacf572e429a01","42":"48f9b7529006e539561a","43":"85de7553ff96cb7219f1","44":"822e572b18a837d72a9d","45":"0b15732891a86aa310e5","46":"a0f152f16cdf5af40241","47":"96ec907f1c9917fb8b00","48":"18a5f89dfb35f56c3af3","49":"cdee3c0e17d0d9bff777","50":"02a51028b4d410254095","51":"3b89bd2ba50fd46b34e7","52":"9991d207274a23eafd82","53":"bedfe140e2e91e32377a","54":"cbedc6e90a8023f7e4f7","55":"f5230e9884df81abecb7","56":"da5b7873c55b3b4f69bc","57":"ee80ebe00feaa7e76cda","58":"e7cb676f540c737ed3aa","59":"f778199e731838bf0f24","60":"98bbd3080deebd998382","61":"f4ed237d88af7a466a15","62":"dc15ac781e865f907314","63":"79fbb8cdfdd864aed7de","64":"de859e00189321f52cf8","65":"546258676cfbacb0937c","66":"23af3e21261107ca940c","67":"721fec81c73adc4942cb","70":"fa49d40660503aa9b52f","71":"e87a340ef0724ab55319"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"5":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"9f7fad396670187e6e81d178f914bce534dfdf3b","1":"a42cee80401c046b0be9e34815118bc8428d9343","2":"70eacc7e437efee67816d4b640fb958822a244a1","3":"0f303393c5cd014f6ff8de21f28f845f7099c261","4":"c98c67519a7e41a1eb7972eefa71518a0b19606b","5":"styles","6":"a320c8ed","7":"11dd2a487fbd0b2bc4903be47570e75ed3b372ab","8":"325e8fbac9e8e621cac8d1682aa7a88b146c49f1","9":"f767f3ab81c56a889b3661ba112fbe4febfbe8de","13":"component---toggl-src-articles-index-js","14":"component---toggl-src-case-studies-index-js","15":"component---toggl-src-downloadables-index-js","16":"component---toggl-src-ebooks-index-js","17":"component---toggl-src-integration-index-js","18":"component---toggl-src-invitation-index-js","19":"component---toggl-src-job-index-js","20":"component---toggl-src-pages-404-js","21":"component---toggl-src-pages-fun-and-games-index-js","22":"component---toggl-src-pages-index-index-js","23":"component---toggl-src-pages-jobs-index-js","24":"component---toggl-src-pages-legal-index-js","25":"component---toggl-src-pages-mission-index-js","26":"component---toggl-src-pages-track-adobe-time-tracking-index-js","27":"component---toggl-src-pages-track-anti-surveillance-statement-index-js","28":"component---toggl-src-pages-track-business-resources-index-js","29":"component---toggl-src-pages-track-completed-signup-js","30":"component---toggl-src-pages-track-contact-js","31":"component---toggl-src-pages-track-culture-index-js","32":"component---toggl-src-pages-track-customers-index-js","33":"component---toggl-src-pages-track-demo-request-confirmation-js","34":"component---toggl-src-pages-track-demo-request-js","35":"component---toggl-src-pages-track-device-unsupported-js","36":"component---toggl-src-pages-track-features-index-js","37":"component---toggl-src-pages-track-forgot-password-js","38":"component---toggl-src-pages-track-freelance-time-tracking-index-js","39":"component---toggl-src-pages-track-index-index-js","40":"component---toggl-src-pages-track-integrations-index-js","41":"component---toggl-src-pages-track-legal-beta-js","42":"component---toggl-src-pages-track-legal-data-protection-js","43":"component---toggl-src-pages-track-legal-index-js","44":"component---toggl-src-pages-track-legal-privacy-js","45":"component---toggl-src-pages-track-legal-sub-processors-js","46":"component---toggl-src-pages-track-legal-terms-js","47":"component---toggl-src-pages-track-login-js","48":"component---toggl-src-pages-track-pricing-index-js","49":"component---toggl-src-pages-track-product-demo-index-js","50":"component---toggl-src-pages-track-productivity-resources-index-js","51":"component---toggl-src-pages-track-sso-link-account-js","52":"component---toggl-src-pages-track-sso-login-js","53":"component---toggl-src-pages-track-sso-must-link-js","54":"component---toggl-src-pages-track-time-management-index-js","55":"component---toggl-src-pages-track-time-tracking-large-teams-index-js","56":"component---toggl-src-pages-track-time-tracking-small-teams-index-js","57":"component---toggl-src-pages-track-toggl-button-feedback-js","58":"component---toggl-src-pages-track-toggl-button-login-js","59":"component---toggl-src-paid-ad-landing-pages-index-js","60":"component---toggl-src-personas-index-js","61":"component---toggl-src-product-index-js","62":"component---toggl-src-signup-index-js","63":"component---toggl-src-spokes-index-js","64":"component---toggl-src-templates-track-reset-password-js","65":"component---toggl-src-templates-track-unsubscribe-js","66":"component---toggl-src-timer-index-js","67":"component---toggl-src-webinars-index-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"f56c0cc9ef93d9e0458f","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://public-assets.toggl.com/b/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
